import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: {
  hasBottomButtons?: boolean;
  width?: number;
  height?: number;
  fontFamily?: string;
}) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      cartViewOuterContainer: {
        padding: '0px 24px 24px 24px',
        minWidth: '100%',
        background: 'transparent'
      },
      cartInnerContainer: {
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        borderRadius: '8px',
        minWidth: '100%',
        overflow: 'hidden',
        height: '809px',
        background: 'white',
        padding: '32px 64px 24px 64px',
        justifyContent: 'space-between',
        color: '#2A2A2A',
        flexWrap: 'nowrap',
        [theme.breakpoints.down('lg')]: {
          height: '1620px',
          padding: '32px 20px',
          marginBottom: '16px'
        }
      },
      cartContentArea: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        width: '100%',
        minHeight: '500px'
      },
      cartBottomArea: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        marginTop: '20px'
      },
      cartHeaderArea: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      },
      cartHeading: {
        flex: 'none',
        background: 'transparent',
        margin: '0px 0px 16px 0px',
        [theme.breakpoints.down('lg')]: {
          padding: '0px 0px 0px 40px',
          width: '100%'
        }
      },
      cartViewButtons: {
        flex: 'none',
        background: 'transparent',
        display: 'inline-flex',
        [theme.breakpoints.down('lg')]: {
          display: 'none'
        },
        '& > *': {
          margin: '0px 0px 0px 24px'
        }
      },
      cartViewButtonsPortrait: {
        display: 'none',
        [theme.breakpoints.down('lg')]: {
          display: 'inline-flex',
          flexWrap: 'wrap',
          gap: '20px',
          justifyContent: 'space-between',
          padding: '0px 10px',
          margin: '20px 0px'
        }
      },
      cartWrapTextButton: {
        width: '400px',
        minWidth: '400px !important',
        whiteSpace: 'normal'
      },
      cartTotalAmountBlock: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
        background: 'transparent',
        flexWrap: 'wrap',
        [theme.breakpoints.down('lg')]: {
          padding: '0 10px'
        }
      },
      cardAmountDivider: {
        height: '1px',
        background: '#9B9B9B',
        color: 'white',
        minWidth: '100%',
        margin: '10px 0 20px'
      },
      // Donation Overlay Styles
      overlayContainer: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignContent: 'center',
        borderRadius: '8px',
        backgroundColor: 'white',
        padding: '56px 45px 20px 45px',
        justifyContent: 'space-around',
        boxShadow: '0 3px 9px 0 rgba(0, 0, 0, 0.2)',
        width: props.width ? props.width : 1160,
        maxHeight: props.height ? props.height : 1000,
        [theme.breakpoints.down('lg')]: {
          width: 1010
        }
      },
      cancelButton: {
        maxWidth: 470,
        minWidth: 450,
        [theme.breakpoints.down('lg')]: {
          maxWidth: 460,
          minWidth: 420
        }
      },
      confirmButton: {
        maxWidth: 470,
        minWidth: 450,
        [theme.breakpoints.down('lg')]: {
          maxWidth: 460,
          minWidth: 420
        }
      },
      donationTileCheckbox: {
        width: '100%',
        height: '100%',
        justifyContent: 'space-between'
      }
    })
  );
